function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "trash",
  d: "M6,2V1A1,1,0,0,1,7,0h4a1,1,0,0,1,1,1V2h4a2,2,0,0,1,2,2V5a2,2,0,0,1-2,2h-.133l-.68,10.2A3,3,0,0,1,12.194,20H5.826a3,3,0,0,1-2.993-2.8L2.137,7H2A2,2,0,0,1,0,5V4A2,2,0,0,1,2,2ZM16,4H2V5H16ZM4.141,7l.687,10.068a1,1,0,0,0,1,.932h6.368a1,1,0,0,0,1-.934L13.862,7H4.142ZM7,8A1,1,0,0,1,8,9v7a1,1,0,0,1-2,0V9A1,1,0,0,1,7,8Zm4,0a1,1,0,0,1,1,1v7a1,1,0,0,1-2,0V9A1,1,0,0,1,11,8Z",
  fill: "#d23737"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default ForwardRef;